import { Phone, Mail, Globe } from "lucide-react";
import { CONTACT, RERA } from "@/constants/content";
import { scrollToSection } from "@/hooks/useLenis";

const LINKS = [
  { href: "#about", label: "About" },
  { href: "#highlights", label: "Highlights" },
  { href: "#pricing", label: "Pricing" },
  { href: "#payment-plan", label: "Payment Plan" },
  { href: "#gallery", label: "Gallery" },
  { href: "#faq", label: "FAQ" },
  { href: "#rera", label: "RERA" },
];

export const Footer = () => {
  const go = (href) => scrollToSection(href);
  return (
    <footer id="contact" className="cp-footer" data-testid="site-footer">
      <div className="cp-container cp-footer-grid">
        <div className="cp-footer-brand">
          <img src="/brochure/logo.png" alt="Buildaxis Developers" data-testid="footer-logo" />
          <p>Buildaxis Developers — Promoter of Central Plaza, Sector 10A, Kharkhoda, Sonipat.</p>
        </div>

        <div className="cp-footer-col">
          <h4>Explore</h4>
          {LINKS.map((l) => (
            <button key={l.href} onClick={() => go(l.href)} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
              {l.label}
            </button>
          ))}
        </div>

        <div className="cp-footer-col">
          <h4>Contact</h4>
          <a href={`tel:${CONTACT.phone1Tel}`} data-testid="footer-phone1-link"><Phone size={14} /> {CONTACT.phone1}</a>
          <a href={`tel:${CONTACT.phone2Tel}`} data-testid="footer-phone2-link"><Phone size={14} /> {CONTACT.phone2}</a>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link"><Mail size={14} /> {CONTACT.email}</a>
          <a href={`https://${CONTACT.website}`} target="_blank" rel="noreferrer" data-testid="footer-website-link"><Globe size={14} /> {CONTACT.website}</a>
        </div>
      </div>
      <div className="cp-footer-bottom">
        <span>© {new Date().getFullYear()} Buildaxis Developers. All rights reserved.</span>
        <span>
          RERA {RERA.number} · Registered {RERA.registeredOn} · License valid until{" "}
          {RERA.licenseValidUntil}
        </span>
      </div>
    </footer>
  );
};
